import { ANNUAL_TRIAL_DAYS, MONTHLY_TRIAL_DAYS } from "../../models/types/subscription.type";
import { SubscriptionView } from "../../models/view/subscription/subscription.view";

const MS_PER_DAY = 24 * 60 * 60 * 1000;
const YEAR = "year";

export class HelperTrialRemaining {
  addDays(date: Date, day: number) {
    return new Date(date.getTime() + day * MS_PER_DAY);
  }

  calculateRemainingDay(date1: Date, date2: Date) {
    const d1 = this.normalizeDate(date1);
    const d2 = this.normalizeDate(date2);
    return Math.floor((d1.getTime() - d2.getTime()) / MS_PER_DAY);
  }

  normalizeDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  getTrialRemaining(activeSubscription: SubscriptionView) {
    const trialPeriod: number =
      activeSubscription.paymentCycle === YEAR ? ANNUAL_TRIAL_DAYS : MONTHLY_TRIAL_DAYS;
    const trialEnd: Date = this.addDays(activeSubscription.startDate, trialPeriod);
    return this.calculateRemainingDay(trialEnd, new Date());
  }

  /** Remaining trial days, or null when there is no active trial or it has ended. */
  getTrialRemainingDays(subscription: SubscriptionView | null | undefined): number | null {
    if (!subscription || !subscription.startDate) {
      return null;
    }
    const remaining = this.getTrialRemaining(subscription);
    return remaining >= 0 ? remaining : null;
  }

  /** True when the subscription is currently within its free-trial window. */
  isInTrialPeriod(subscription: SubscriptionView | null | undefined): boolean {
    const remaining = this.getTrialRemainingDays(subscription);
    return remaining !== null && remaining > 0;
  }

  /** The next billing/renewal date, or null if none. */
  getNextBillingDate(subscription: SubscriptionView | null | undefined): Date | null {
    return subscription?.renewalDate || null;
  }

  /** Format a date as YYYY-MM-DD for display (empty string when null). */
  formatBillingDate(date: Date | null | undefined): string {
    if (!date) {
      return "";
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
}
